module.exports = __webpack_public_path__ + "img/tour-arrow-left.svg";